/* Override default nav item link styles */
.link {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 8px !important;
    margin: 2px 0 !important;
}

.link--two-line {
    composes: link;
    padding: 3px 8px 6px 8px !important;
}

/* Ensure we truncate name if it's too long */
.nav-item-name {
    font-size: 12px;
    padding-right: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.nav-item-count {
    padding-right: 12px;
}

.nav-item-name--two-line {
    composes: nav-item-name;
    line-height: 15px;
    padding-bottom: 1px;
}

.nav-item-second-line {
    font-size: 11px;
    height: 11px;
    line-height: 11px;
    padding-top: 2px;
    padding-right: 12px;
    color: #9b9ec1;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.action-menu-container {
    position: absolute;
    top: 9px;
    right: 5px;
    border-radius: 3px;
}

.action-menu-container > *:first-child {
    padding: 2px 4px;
    border-radius: 3px;
}
